module.exports = __webpack_public_path__ + "img/ashreshteh-header.e49b5002.png";